import React, {Component} from 'react'
import ReactQuill from 'react-quill'

import './quill.snow.css'

export default class QuillEditor extends Component {

  componentWillMount() {
    this.modules = {
      toolbar: {
        container: [
          ['bold', 'italic', 'underline','strike'],
          [{ 'header': 1 }, { 'header': 2 }],
          [{'list': 'ordered'}, {'list': 'bullet'},],
          [{ 'align': '' }, { 'align': 'center' }, { 'align': 'right' }],
          ['link', 'image', 'video']
        ],

        handlers: {
          'image': () => {
            var quill = this.refs.quill.getEditor()
            const input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.click();


            // Listen upload local image and save to server
            input.onchange = function() {
                const file = input.files[0];
                // file type is only image.
                if (/^image\//.test(file.type)) {
                    var reader = new FileReader()
                    reader.onload = function (e) {
                      let range = quill.getSelection()
                      let img = quill.insertEmbed(range.index, 'image', e.target.result, 'user')
                      let index = 0
                      if(img.ops[0].retain)
                        index = 1
                      
                      img = quill.root.querySelector('[src="'+img.ops[index].insert.image+'"]')
                      this.props.onUploadImage(img, file)
                    }.bind(this)
                    reader.readAsDataURL(file);
                }
            }.bind(this)
          }
        }
      }
    }
  }
    
  render() {
    return (
      <ReactQuill
        ref='quill'
        value={this.props.value || ''}
        onChange={(e) => { this.props.onChange(e) }}
        modules={this.modules}
        placeholder={this.props.placeholder || ''}
        />
    )
  }
}



// WEBPACK FOOTER //
// ./src/SPRINTA/third-party/QuillEditor/index.js